import React from 'react';

import {
  minValue,
  required,
  SelectInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import { useWatch } from 'react-hook-form';

import PriorityParameters from './PriorityParameters';
import ThresholdModeSelector from './ThresholdModeSelector';
import KycFormDataMaxAgeInput from './KycFormDataMaxAgeInput';
import { DefaultThresholdInput, KycFormThresholdInput } from './ThresholdInput';

import NumberInput from '../../layout/inputFields/NumberInput';

import Label from '../../../customFields/Label';

import { timePeriodChoices } from '../../../constants/timePeriods';
import thresholdModes from '../../../constants/thresholdModes';
import TransactionTypeConfiguration from './TransactionTypeConfiguration';
import transactionMonitoringModes, { transactionMonitoringModesChoices } from '../../../constants/transactionMonitoringMode';

const TransactionRollingSum = () => {
  const thresholdMode = useWatch({ name: 'ruleParameters.thresholdMode' });

  const showDefault = thresholdMode === thresholdModes.DEFAULT_ONLY
    || thresholdMode === thresholdModes.BOTH;
  const showForm = thresholdMode === thresholdModes.KYC_ONLY
    || thresholdMode === thresholdModes.BOTH;
  const showPriority = thresholdMode === thresholdModes.BOTH;

  return (
    <Grid size={12}>
      <Grid container>
        <Grid size={12}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <TransactionTypeConfiguration />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <SelectInput
                source="ruleParameters.transactionMonitoringMode"
                choices={transactionMonitoringModesChoices}
                fullWidth
                label="Transaction monitoring mode"
                validate={[required()]}
                defaultValue={transactionMonitoringModes.ALL_RELATED}
              />
            </Grid>
            <ThresholdModeSelector />
            {showDefault && (
              <Grid size={12}>
                <DefaultThresholdInput />
              </Grid>
            )}
            {showForm && (
              <Grid size={12}>
                <KycFormThresholdInput
                  displayText="Deviation in %"
                  allowCommon
                />
              </Grid>
            )}
            {showForm && <KycFormDataMaxAgeInput />}

            <Grid size={12}>
              <Label
                variant="label"
                title="Period"
                info="The period that the threshold will be checked against."
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <NumberInput
                source="ruleParameters.period.amount"
                fullWidth
                label="Length"
                validate={[required(), minValue(1)]}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <SelectInput
                source="ruleParameters.period.unit"
                choices={timePeriodChoices}
                fullWidth
                label="Period"
                validate={[required(), minValue(1)]}
              />
            </Grid>
          </Grid>
        </Grid>
        {showPriority && <PriorityParameters />}
      </Grid>
    </Grid>
  );
};

export default TransactionRollingSum;
